/**
 * <p-variant-sku> — zeigt die Artikelnummer (SKU) der gewählten Variante.
 * Hört auf Theme Produkt-Auswahl-Event am Abschnitt und übernimmt resource.sku.
 * Genutzt im GPSR-Dialog (blocks/p-gpsr.liquid).
 */
import { StandardEvents } from '@shopify/events';

if (!customElements.get('p-variant-sku')) {
  class PVariantSku extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.section?.addEventListener(StandardEvents.productSelect, this.onSelect);
    }

    disconnectedCallback() {
      this.section?.removeEventListener(StandardEvents.productSelect, this.onSelect);
    }

    onSelect = (event) => {
      event.promise
        ?.then(({ detail }) => {
          if (detail?.resource) this.textContent = detail.resource.sku || '';
        })
        .catch(() => {});
    };
  }

  customElements.define('p-variant-sku', PVariantSku);
}
